import { akedlyInboxQueryKeys as e } from "./akedlyInboxQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/useAkedlyInboxStatsQuery.ts
var r = () => t({
	queryKey: e.stats(),
	queryFn: () => n.inboxStats()
});
//#endregion
export { r as useAkedlyInboxStatsQuery };
